import { render, staticRenderFns } from "./lookComment.vue?vue&type=template&id=1365208a&scoped=true"
import script from "./lookComment.vue?vue&type=script&lang=js"
export * from "./lookComment.vue?vue&type=script&lang=js"
import style0 from "./lookComment.vue?vue&type=style&index=0&id=1365208a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1365208a",
  null
  
)

export default component.exports